import { render, staticRenderFns } from "./m-services.vue?vue&type=template&id=13f73762&scoped=true"
import script from "./m-services.vue?vue&type=script&lang=js"
export * from "./m-services.vue?vue&type=script&lang=js"
import style0 from "./m-services.vue?vue&type=style&index=0&id=13f73762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f73762",
  null
  
)

export default component.exports